(function () {
  var shade = document.querySelector('[data-cart-shade]');
  var drawer = document.querySelector('[data-cart-drawer]');
  var itemsEl = document.querySelector('[data-cart-items]');
  var subtotalEl = document.querySelector('[data-cart-subtotal]');
  var countEls = document.querySelectorAll('[data-cart-count]');

  function openCart() {
    if (shade) shade.classList.add('open');
    if (drawer) drawer.classList.add('open');
  }
  function closeCart() {
    if (shade) shade.classList.remove('open');
    if (drawer) drawer.classList.remove('open');
  }

  document.querySelectorAll('[data-cart-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () { renderCart(); openCart(); });
  });
  document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
    btn.addEventListener('click', closeCart);
  });
  if (shade) shade.addEventListener('click', closeCart);

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function renderCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        countEls.forEach(function (el) { el.textContent = cart.item_count; });
        if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
        if (!itemsEl) return;
        if (cart.items.length === 0) {
          itemsEl.innerHTML = '<p style="text-align:center;margin-top:80px">Your ritual awaits.<br><small>Your bag is empty.</small></p>';
          return;
        }
        itemsEl.innerHTML = cart.items.map(function (item) {
          return '' +
            '<div class="lq-row">' +
              '<div>' +
                '<h4>' + item.product_title + '</h4>' +
                '<small>' + money(item.price) + '</small>' +
                '<div class="lq-qty">' +
                  '<button type="button" data-qty-change="' + item.key + '" data-delta="-1">−</button>' +
                  '<span>' + item.quantity + '</span>' +
                  '<button type="button" data-qty-change="' + item.key + '" data-delta="1">+</button>' +
                '</div>' +
              '</div>' +
              '<b>' + money(item.line_price) + '</b>' +
            '</div>';
        }).join('');
      });
  }

  document.body.addEventListener('click', function (e) {
    var buyNowBtn = e.target.closest('[data-buy-now]');
    if (buyNowBtn) {
      e.preventDefault();
      if (buyNowBtn.disabled) return;
      var variantId = buyNowBtn.getAttribute('data-variant-id');
      if (!variantId) return;
      buyNowBtn.disabled = true;
      buyNowBtn.setAttribute('aria-busy', 'true');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to add item');
          return response.json();
        })
        .then(function () {
          window.location.assign('/checkout');
        })
        .catch(function () {
          buyNowBtn.disabled = false;
          buyNowBtn.removeAttribute('aria-busy');
        });
    }

    var qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      var key = qtyBtn.getAttribute('data-qty-change');
      var delta = parseInt(qtyBtn.getAttribute('data-delta'), 10);
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var item = cart.items.find(function (i) { return i.key === key; });
          if (!item) return;
          var newQty = Math.max(0, item.quantity + delta);
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: newQty })
          }).then(function () { renderCart(); });
        });
    }

    var faqBtn = e.target.closest('[data-faq-toggle]');
    if (faqBtn) {
      var answer = faqBtn.parentElement.querySelector('.lq-answer');
      var expanded = faqBtn.getAttribute('aria-expanded') === 'true';
      faqBtn.setAttribute('aria-expanded', String(!expanded));
      if (answer) answer.style.display = expanded ? 'none' : 'block';
    }
  });

  renderCart();
})();

/* ===== Scroll-reveal entrance animation ===== */
(function () {
  var items = document.querySelectorAll('.lq-reveal');
  if (!items.length) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion || !('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('in-view'); });
    return;
  }

  // Stagger siblings that reveal together (product grid, trust bar, reviews, faq)
  var counters = new WeakMap();
  items.forEach(function (el) {
    var parent = el.parentElement;
    if (!parent) return;
    var n = counters.get(parent) || 0;
    el.style.transitionDelay = (n * 90) + 'ms';
    counters.set(parent, n + 1);
  });

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

  items.forEach(function (el) { io.observe(el); });
})();

/* ===== Product page gallery (thumbnail click) ===== */
(function () {
  document.querySelectorAll('.lq-product-gallery').forEach(function (gallery) {
    var main = gallery.querySelector('.lq-product-main');
    var thumbsWrap = gallery.querySelector('.lq-product-thumbs');
    if (!main || !thumbsWrap) return;
    var slides = main.querySelectorAll('.lq-slide');
    var thumbs = thumbsWrap.querySelectorAll('.lq-thumb');

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-thumb'), 10);
        slides.forEach(function (s, si) { s.classList.toggle('is-active', si === idx); });
        thumbs.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      });
    });
  });
})();

/* ===== Product card image slideshow (with dot navigation) ===== */
(function () {
  var cards = document.querySelectorAll('.lq-card-art');
  if (!cards.length) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  cards.forEach(function (art) {
    var slides = art.querySelectorAll('.lq-slide');
    var dots = art.querySelectorAll('.lq-dot');
    if (slides.length < 2) return;

    var index = 0;
    var timer = null;

    function show(i) {
      index = i;
      slides.forEach(function (s, si) { s.classList.toggle('is-active', si === i); });
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
    }
    function next() {
      show((index + 1) % slides.length);
    }
    function start() {
      if (reduceMotion) return;
      stop();
      timer = setInterval(next, 2600);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        show(parseInt(dot.getAttribute('data-dot'), 10));
        start();
      });
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) start(); else stop();
        });
      }, { threshold: 0.4 });
      io.observe(art);
    } else if (!reduceMotion) {
      start();
    }

    art.addEventListener('mouseenter', stop);
    art.addEventListener('mouseleave', function () {
      var rect = art.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) start();
    });
  });
})();
